import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "../css/WebD.css";
import AnimatedBack from "../images/AnimatedBack.gif";
import AnimatedWedb from "../images/AnimatedWebD.gif";
import Webd1 from "../images/Webd1.png";
import Webd2 from "../images/Webd2.png";
import Webd3 from "../images/Webd3.png";
import Webd4 from "../images/Webd4.png";
import Webd5 from "../images/Webd5.png";
import Webd6 from "../images/Webd6.png";
import PHP1 from "../images/PHP1.png";
import PHP2 from "../images/PHP2.png";
import PHP3 from "../images/PHP3.png";
import PHP4 from "../images/PHP4.webp";
import PHP5 from "../images/PHP5.jpeg";
import OS1 from "../images/OS1.jpg";
import OS2 from "../images/OS2.png";
import OS3 from "../images/OS3.jpeg";
import OS4 from "../images/OS4.jpeg";
import OS5 from "../images/OS5.jpeg";
import OS6 from "../images/OS6.webp";
import OS7 from "../images/OS7.jpg";
import HTML1 from "../images/HTML1.webp";
import HTML2 from "../images/HTML2.jpeg";
import HTML3 from "../images/HTML3.jpg";
import HTML4 from "../images/HTML4.jpeg";
import JS1 from "../images/JS1.png";
import JS2 from "../images/JS2.jpeg";
import JS3 from "../images/JS3.jpg";
import JS4 from "../images/JS4.png";
import JS5 from "../images/JS5.jpeg";
import NET1 from "../images/NET1.webp";
import NET2 from "../images/NET2.png";
import Customer from "../components/Customer";

function WebD() {
  const [dropdowns, setDropdowns] = useState({
    PHP: false,
    OS: false,
    HTML: false,
    JS: false,
    ASP: false,
  });

  const toggleDropdown = (service) => {
    setDropdowns((prev) => {
      const resetDropdowns = Object.keys(prev).reduce((acc, key) => {
        acc[key] = false;
        return acc;
      }, {});

      return {
        ...resetDropdowns,
        [service]: !prev[service],
      };
    });
  };

  return (
    <>
      <Header />
      <div className="WebD">
        <div className="Webd-above">
          <img className="Webd-img" src={AnimatedBack} alt="" />
          <div className="Webd-above-info" >
            <p className="Webd-p">Web Development</p>
            <p
              className="Webd-p"
              style={{ marginTop: "-10px", marginBottom: "-10px" }}
            >
              we’re experts
            </p>
            <p className="Webd-p1">
              Web Development Company with Creativity and Intuition that Makes
              Things Happen!
            </p>
          </div>
        </div>
        <div className="Webd-main" >
          <div className="Webd-main1">
            <img className="Webd-main1-img" src={AnimatedWedb} alt="" />
            <div className="Webd-main1-info" >
              <p>
                <strong>Transforming your visions</strong> into a compelling
                design or website is the art of bridging your business goals
                with your target audience. It’s about communicating your genuine
                values, ethical principles, and strategic vision seamlessly.{" "}
                <strong>Purohit Technosoft</strong> specializes in crafting
                corporate websites that are not just visually stunning but also
                highly functional—whether they are static or dynamic,
                responsive, or e-commerce. With a proven track record of
                success, we are the reliable partners you’ve been searching for
                to bring your website dreams to life.
              </p>
              <p>
                <strong>At Purohit Technosoft Solution</strong>, simplicity and
                user comfort are at the core of our web development approach.
                Leveraging the power of open-source platforms,{" "}
                <strong>we create</strong> feature-rich, visually appealing
                websites designed for seamless functionality. Our goal is to
                provide your visitors with an exceptional web experience while
                ensuring that managing your site is effortless.
              </p>
              <p>
                <strong>Our expert development team</strong> excels in utilizing
                open-source technologies to build custom websites tailored to
                your unique business needs. With a focus on efficiency,
                innovation, and user-centric design, <strong>we deliver</strong>{" "}
                web solutions that make your business stand out and thrive in
                the digital landscape.
              </p>
            </div>
          </div>
          <div className="Webd-main2">
            <p className="Webd-main2-p">Comprehensive Web Solutions</p>
            <p className="Webd-main2-p1">
              We offer complete end-to-end web development services, catering to
              a wide spectrum of possibilities.
            </p>
            <div className="Webd-main2-boxes">
              <div className="Webd-main2-box">
                <img className="Webd-main2-img" src={Webd1} alt="" />
                <p
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "24px",
                  }}
                >
                  Optimize Your Website for SEO
                </p>
                <p style={{ marginTop: "20px" }}>
                  Ensure your website is easily accessible and
                  search-engine-friendly with a logical structure and strategic
                  organization. By implementing effective SEO practices,
                  including Title tags, Meta tags, and Alt tags, Google crawlers
                  can index your site quickly. Enhance user engagement by
                  incorporating features like internal links to increase the
                  time visitors spend on your site.
                </p>
              </div>
              <div className="Webd-main2-box">
                <img className="Webd-main2-img" src={Webd2} alt="" />
                <p
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "24px",
                  }}
                >
                  Prioritize Website Security
                </p>
                <p style={{ marginTop: "20px" }}>
                  Protect your website from threats like hacked customer
                  information and data leaks by implementing robust security
                  measures. Ensure your site includes essential elements such as
                  clear contact information, a comprehensive privacy policy,
                  HTTPS for secure browsing, and recognized safety
                  certifications like seals or awards. Build trust and
                  credibility by showcasing customer testimonials, reviews, news
                  features, and ratings.
                </p>
              </div>
              <div className="Webd-main2-box">
                <img className="Webd-main2-img" src={Webd3} alt="" />
                <p
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "24px",
                  }}
                >
                  Optimize Page Load Times
                </p>
                <p style={{ marginTop: "20px" }}>
                  Ensure your website loads quickly to retain user engagement.
                  Google recommends a page load time of three seconds or less.
                  Slow-loading pages increase the likelihood of users leaving
                  your site. Maximize impact by minimizing the use of heavy
                  graphics and focusing on clear, concise content to deliver an
                  efficient and engaging user experience.
                </p>
              </div>
            </div>
            <div className="Webd-main2-boxes">
              <div className="Webd-main2-box">
                <img className="Webd-main2-img" src={Webd4} alt="" />
                <p
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "24px",
                  }}
                >
                  Prioritize Mobile-Friendliness
                </p>
                <p style={{ marginTop: "20px" }}>
                  With the majority of users accessing information via mobile
                  devices, mobile SEO is now essential. Google rewards
                  mobile-friendly websites with higher search engine rankings.
                  Implement responsive designs to ensure seamless cross-platform
                  compatibility and enhance online sharing, providing an optimal
                  experience for users on any device.
                </p>
              </div>
              <div className="Webd-main2-box">
                <img className="Webd-main2-img" src={Webd5} alt="" />
                <p
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "24px",
                  }}
                >
                  Deliver Exceptional Customer Experience
                </p>
                <p style={{ marginTop: "20px" }}>
                  Boost conversion rates and revenue with a website designed for
                  seamless navigation and intuitive architecture, tailored to
                  user behavior and research. As a leading web design firm, we
                  offer top-notch design services and advanced features to help
                  you achieve outstanding results and enhance user satisfaction.
                </p>
              </div>
              <div className="Webd-main2-box">
                <img className="Webd-main2-img" src={Webd6} alt="" />
                <p
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "24px",
                  }}
                >
                  Engaging Interactive Design
                </p>
                <p style={{ marginTop: "20px" }}>
                  We specialize in creating interactive designs that captivate
                  your audience and are easy to navigate. Recognizing the
                  importance of user interaction, we deliver exceptional
                  services tailored to your needs. Each design is uniquely
                  crafted for our clients, ensuring modern, up-to-date layouts
                  that stand out—never relying on outdated templates.
                </p>
              </div>
            </div>
          </div>
          <div className="Webd-main3">
            <p className="Webd-main3-p">
              Services we offers for Web Development
            </p>
            <p className="Webd-main3-p1">
              Excellence and innovation Using the Most Recent Technology
            </p>
            <div className="Webd-main3-options">
              <div
                className="Webd-main3-option"
                onClick={() => toggleDropdown("PHP")}
              >
                <i className="fa-brands fa-php fa-xl"></i>
                <p>PHP</p>
                {dropdowns.PHP && (
                  <div className="dropdown-info">
                    <p
                      style={{
                        fontSize: "20px",
                        color: "white",
                        fontWeight: "medium",
                      }}
                    >
                      PHP is a widely-used, open-source, server-side programming
                      language favored by developers. Its seamless integration
                      with HTML makes it an ideal choice for building complex
                      and dependable websites.
                    </p>
                    <div className="dropdown-info-images">
                      <div className="dropdown-images-box">
                        <img
                          className="dropdown-info-image"
                          src={PHP1}
                          alt=""
                        />
                        <p style={{ fontSize: "18px", color: "white" }}>
                          CodeIgniter
                        </p>
                      </div>
                      <div className="dropdown-images-box">
                        <img
                          className="dropdown-info-image"
                          src={PHP2}
                          alt=""
                        />
                        <p style={{ fontSize: "18px", color: "white" }}>
                          Laravel
                        </p>
                      </div>
                      <div className="dropdown-images-box">
                        <img
                          className="dropdown-info-image"
                          src={PHP3}
                          alt=""
                        />
                        <p style={{ fontSize: "18px", color: "white" }}>
                          Cake PHP
                        </p>
                      </div>
                      <div className="dropdown-images-box">
                        <img
                          className="dropdown-info-image"
                          src={PHP4}
                          alt=""
                        />
                        <p style={{ fontSize: "18px", color: "white" }}>YII</p>
                      </div>
                      <div className="dropdown-images-box">
                        <img
                          className="dropdown-info-image"
                          src={PHP5}
                          alt=""
                        />
                        <p style={{ fontSize: "18px", color: "white" }}>Zend</p>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div
                className="Webd-main3-option"
                onClick={() => toggleDropdown("OS")}
              >
                <i className="fa-brands fa-osi fa-xl"></i>
                <p>Open Source</p>
                {dropdowns.OS && (
                  <div
                    className="dropdown-info"
                    style={{ marginLeft: "-250px" }}
                  >
                    <p
                      style={{
                        fontSize: "20px",
                        color: "white",
                        fontWeight: "medium",
                      }}
                    >
                      We utilize open-source technologies, tools, and frameworks
                      to help your business website stand out, as they form the
                      backbone of your online presence. The open design allows
                      your team to contribute creatively, enabling a website
                      that is highly customizable, secure, and versatile.
                    </p>
                    <div className="dropdown-info-images">
                      <div className="dropdown-images-box">
                        <img className="dropdown-info-image" src={OS1} alt="" />
                        <p style={{ fontSize: "18px", color: "white" }}>
                          Drupal
                        </p>
                      </div>
                      <div className="dropdown-images-box">
                        <img className="dropdown-info-image" src={OS2} alt="" />
                        <p style={{ fontSize: "18px", color: "white" }}>
                          Joomla
                        </p>
                      </div>
                      <div className="dropdown-images-box">
                        <img className="dropdown-info-image" src={OS3} alt="" />
                        <p style={{ fontSize: "18px", color: "white" }}>
                          Magento
                        </p>
                      </div>
                      <div className="dropdown-images-box">
                        <img className="dropdown-info-image" src={OS4} alt="" />
                        <p style={{ fontSize: "18px", color: "white" }}>
                          Open Cart
                        </p>
                      </div>
                      <div className="dropdown-images-box">
                        <img className="dropdown-info-image" src={OS5} alt="" />
                        <p style={{ fontSize: "18px", color: "white" }}>
                          Presta Shop
                        </p>
                      </div>
                      <div className="dropdown-images-box">
                        <img className="dropdown-info-image" src={OS6} alt="" />
                        <p style={{ fontSize: "18px", color: "white" }}>
                          Shopify
                        </p>
                      </div>
                      <div className="dropdown-images-box">
                        <img className="dropdown-info-image" src={OS7} alt="" />
                        <p style={{ fontSize: "18px", color: "white" }}>
                          WordPress
                        </p>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div
                className="Webd-main3-option"
                onClick={() => toggleDropdown("HTML")}
              >
                <i className="fa-brands fa-html5 fa-xl"></i>
                <p>HTML5 & CSS3</p>
                {dropdowns.HTML && (
                  <div
                    className="dropdown-info"
                    style={{ marginLeft: "-500px" }}
                  >
                    <p
                      style={{
                        fontSize: "20px",
                        color: "white",
                        fontWeight: "medium",
                      }}
                    >
                      Develop websites that deliver an intuitive user experience
                      across multiple devices, browsers, and platforms, while
                      enhancing browsing performance and optimizing local data
                      storage.
                    </p>
                    <div className="dropdown-info-images">
                      <div className="dropdown-images-box">
                        <img
                          className="dropdown-info-image"
                          src={HTML1}
                          alt=""
                        />
                        <p style={{ fontSize: "18px", color: "white" }}>
                          BootStrap
                        </p>
                      </div>
                      <div className="dropdown-images-box">
                        <img
                          className="dropdown-info-image"
                          src={HTML2}
                          alt=""
                        />
                        <p style={{ fontSize: "18px", color: "white" }}>CSS3</p>
                      </div>
                      <div className="dropdown-images-box">
                        <img
                          className="dropdown-info-image"
                          src={HTML3}
                          alt=""
                        />
                        <p style={{ fontSize: "18px", color: "white" }}>
                          Grid System
                        </p>
                      </div>
                      <div className="dropdown-images-box">
                        <img
                          className="dropdown-info-image"
                          src={HTML4}
                          alt=""
                        />
                        <p style={{ fontSize: "18px", color: "white" }}>
                          HTML5
                        </p>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div
                className="Webd-main3-option"
                onClick={() => toggleDropdown("JS")}
              >
                <i className="fa-brands fa-square-js fa-xl"></i>
                <p>JavaScript</p>
                {dropdowns.JS && (
                  <div
                    className="dropdown-info"
                    style={{ marginLeft: "-750px" }}
                  >
                    <p
                      style={{
                        fontSize: "20px",
                        color: "white",
                        fontWeight: "medium",
                      }}
                    >
                      We excel in JavaScript, creating highly responsive
                      interfaces that enhance customer experiences and provide
                      dynamic functionality. Leveraging one of the most
                      versatile programming languages with extensive
                      repositories, we implement features like search boxes with
                      predictive suggestions, seamless content loading, and
                      engaging on-page animations.
                    </p>
                    <div className="dropdown-info-images">
                      <div className="dropdown-images-box">
                        <img className="dropdown-info-image" src={JS1} alt="" />
                        <p style={{ fontSize: "18px", color: "white" }}>
                          Angular JS
                        </p>
                      </div>
                      <div className="dropdown-images-box">
                        <img className="dropdown-info-image" src={JS2} alt="" />
                        <p style={{ fontSize: "18px", color: "white" }}>
                          JQuery
                        </p>
                      </div>
                      <div className="dropdown-images-box">
                        <img className="dropdown-info-image" src={JS3} alt="" />
                        <p style={{ fontSize: "18px", color: "white" }}>
                          Node Js
                        </p>
                      </div>
                      <div className="dropdown-images-box">
                        <img className="dropdown-info-image" src={JS4} alt="" />
                        <p style={{ fontSize: "18px", color: "white" }}>
                          React Js
                        </p>
                      </div>
                      <div className="dropdown-images-box">
                        <img className="dropdown-info-image" src={JS5} alt="" />
                        <p style={{ fontSize: "18px", color: "white" }}>
                          Vue Js
                        </p>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div
                className="Webd-main3-option"
                onClick={() => toggleDropdown("ASP")}
              >
                <i className="fa-brands fa-battle-net fa-xl"></i>
                <p>ASP .Net</p>
                {dropdowns.ASP && (
                  <div
                    className="dropdown-info"
                    style={{ marginLeft: "-1000px" }}
                  >
                    <p
                    style={{
                      fontSize: "20px",
                      color: "white",
                      fontWeight: "medium",
                    }}>
                      Using a powerful server-side application framework, we
                      develop dynamic and scalable web pages. Our developers
                      maximize the potential of just-in-time compilation, native
                      optimization, and caching services. With ASP.NET, we
                      deliver enterprise-grade websites and web applications
                      tailored to meet complex business needs.
                    </p>
                    <div className="dropdown-info-images">
                      <div className="dropdown-images-box">
                        <img className="dropdown-info-image" src={NET1} alt="" />
                        <p style={{ fontSize: "18px", color: "white" }}>
                          .Net MVC
                        </p>
                      </div>
                      <div className="dropdown-images-box">
                        <img className="dropdown-info-image" src={NET2} alt="" />
                        <p style={{ fontSize: "18px", color: "white" }}>
                          .Net Core
                        </p>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          
            
        </div>
      </div>
      <Customer/>
      <Footer />
    </>
  );
}

export default WebD;
